import React from "react";
import { Link, useLocation } from "react-router-dom";

function NavBarBSA1() {

    const location = useLocation();

    return (
        <nav className="flex flex-row justify-around">
            <Link to="/bsa1/production" className={`${location.pathname === '/bsa1/production' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-400`}>
                BSA 1
            </Link>
            <Link to="/bsa1/kaga" className={`${location.pathname === '/bsa1/kaga' ? 'bg-slate-600 text-white font-bold' : ''} w-full border border-gray-400 text-center p-2 hover:bg-gray-200`}>
                KaGA
            </Link>
        </nav>
    );
}

export default NavBarBSA1